import { decodeHtmlEntity } from '@/utils/product';

function Description({ description = '' }) {
  return (
    <section className='custom_description mx-auto bg-gray-100 px-8 py-3 max-sm:w-full max-sm:px-3'>
      <div
        className='max-md:text-sm max-sm:text-xs'
        dangerouslySetInnerHTML={{
          __html: decodeHtmlEntity(description)
            ?.replaceAll(
              '"{{media url="',
              `${process.env.NEXT_PUBLIC_IMG_BASEURL}/`
            )
            ?.replaceAll(`/media/" `, '/media/')
            ?.replaceAll('"}}"', '')
            ?.replaceAll(
              '{{media url=',
              `${process.env.NEXT_PUBLIC_IMG_BASEURL}/`
            )
            ?.replaceAll('}}', ''),
        }}
      />
    </section>
  );
}

export default Description;
